import getId from './getId'
import getColumnId from './getColumnId'
import getTableId from './getTableId'

export { getId, getColumnId, getTableId }
